import { Routes, Route } from "react-router-dom";
import Grid from "@mui/material/Grid";


import SubscriptionDetailsPage from "./ui-components/SubscriptionDetailsPage";
import NavBar from "./ui-components/NavBar";
import Stack from "@mui/material/Stack";

function App() {
    return (
        <Stack spacing={4}>
            <NavBar />
            <Grid container justifyContent="center">
                <Routes>
                    <Route path="/" element={<SubscriptionDetailsPage />} />
                </Routes>
            </Grid>
        </Stack>
    );
}

export default App;
